import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { DataService } from '../services/data.service';
import { TranslateService } from '@ngx-translate/core';
import { Subject, timer } from 'rxjs';
import { switchMap, takeUntil, takeWhile, tap } from 'rxjs/operators';
import { ErrorMessagesModalComponent } from '../modals/error-messages-modal.component';
import { BsModalService } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-import-progress-toast',
  templateUrl: './import-progress-toast.component.html',
})
export class ImportProgressToastComponent implements OnInit, OnDestroy {
  title: string = '';
  description: string = '';
  progress: number = 0;
  status: 'completed' | 'processing' | 'failed' | 'pending' = 'pending';
  show: boolean = false;
  @Input() importId: number = 0;
  /** Index among visible toastrs; used to stack vertically (0 = first, 1 = second, etc.) */
  @Input() index: number = 0;
  @Output() closeToastr = new EventEmitter<{ id: number; refresh: boolean }>();
  errorMessages: string[] = [];

  private readonly destroy$ = new Subject<void>();

  constructor(
    private dataService: DataService,
    private translate: TranslateService,
    private bsModalService: BsModalService,
  ) { }

  ngOnInit(): void {
    timer(0, 5_000)
      .pipe(
        switchMap(() =>
          this.dataService.get(`api/entity-imports/${this.importId}`),
        ),
        tap((data: any) => {
          const type = data.type;
          this.title =
            this.translate.instant(`import_progress_toast.${type}.importing`) +
            ' ' +
            data.file_name;
          this.description =
            this.translate.instant(`import_progress_toast.${type}.imported`) +
            ': <strong>' +
            data.success_records +
            '/' +
            (data.total_records == 0 ? '∞' : data.total_records) +
            '</strong>';
          this.progress = data.progress_percentage;
          this.status = data.status;
          this.errorMessages = data.error_messages;
          this.show = true;
        }),
        // keep polling only while processing or pending; emit the final non-processing state then complete
        takeWhile(
          (data: any) =>
            data.status === 'processing' || data.status === 'pending',
          true,
        ),
        takeUntil(this.destroy$),
      )
      .subscribe({
        error: () => {
          this.status = 'failed';
          this.show = true;
        },
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onCloseClick(): void {
    this.show = false;
    this.closeToastr.emit({ id: this.importId, refresh: false });
  }

  displayErrorMessages() {
    this.bsModalService.show(ErrorMessagesModalComponent, {
      initialState: {
        errorMessages: this.errorMessages,
      },
    });
  }

  closeAndRefresh() {
    this.show = false;
    this.closeToastr.emit({ id: this.importId, refresh: true });
  }
}
